module.exports = __webpack_public_path__ + "img/moneymex_desc_vi4.b88ede79.webp";